import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import CancelableChip from '../Chips/CancelableChip'
import css from './styles.css'

const containerClasses = cx(css.wrapper, css.filtersContainer)

const FilterClearBar = ({
  handleClearFilter,
  filterTimeRange,
  selectedAppointmentTypeIds,
  selectedDoctorId,
  selectedLocationId,
  selectedPatientStatusIds,
  totalPatients,
}) => {
  const hasFilters = [
    {
      label: 'Doctor',
      hasContent: !!selectedDoctorId.length,
      type: 'selectedDoctorId',
    },
    {
      label: 'Location',
      hasContent: !!selectedLocationId.length,
      type: 'selectedLocationId',
    },
    {
      label: 'Appointment Types',
      hasContent: !!selectedAppointmentTypeIds.length,
      type: 'selectedAppointmentTypeIds',
    },
    {
      label: 'Patient Statuses',
      hasContent: !!selectedPatientStatusIds.length,
      type: 'selectedPatientStatusIds',
    },
  ]
  const currentFilters = hasFilters.filter(filterType => filterType.hasContent)
  const patientCount = totalPatients !== 1
    ? `are ${totalPatients} patients`
    : 'is 1 patient'

  return (
    <div>
      {((totalPatients > 0 && filterTimeRange !== 'All') ||
        !!currentFilters.length) && (
        <div className={containerClasses}>
          <div className={css.filtersTitle}>Active Filters:</div>
          <div className={css.activeFilterContainer}>
            {currentFilters.map(filter => (
              <CancelableChip
                key={filter.type}
                handleRemoveChip={handleClearFilter}
                id={filter.type}
                title={filter.label}
              />
            ))}
          </div>

          <div className={css.filtersTagline}>
            {`Currently there ${patientCount} found for the time range of ${filterTimeRange}.`}
          </div>
        </div>
      )}
    </div>
  )
}

FilterClearBar.propTypes = {
  handleClearFilter: PropTypes.func.isRequired,
  selectedAppointmentTypeIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  filterTimeRange: PropTypes.string.isRequired,
  selectedDoctorId: PropTypes.string.isRequired,
  selectedLocationId: PropTypes.string.isRequired,
  selectedPatientStatusIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  totalPatients: PropTypes.number.isRequired,
}

export default FilterClearBar



// WEBPACK FOOTER //
// ./src/components/sitewide/Filter/FilterClearBar.js